exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.crop-img-modal .cropper-container{\r\n    margin: auto;\n}\n.ih-box{\n}\r\n", ""]);

// exports
